<template>
  <transition name="fade">
    <span
      class="root"
      v-if="loading"
    >
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  </transition>
</template>


<style lang="scss" scoped>
@keyframes blink {
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
.root {
  display: inline-block;
  span {
    animation-name: blink;
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
  }

  span:nth-child(2) {
    animation-delay: 0.2s;
  }

  span:nth-child(3) {
    animation-delay: 0.4s;
  }
}
</style>


<script>
export default {
  props: {
    loading: { type: Boolean, required: false, default: true }
  }
}
</script>



// WEBPACK FOOTER //
// DotsLoading.vue?b61a6bd8